import { CanvasDrawer } from "./CanvasDrawer";

export function screenToCanvas(e: React.TouchEvent | React.MouseEvent, canvas: HTMLCanvasElement) {
    const rect = canvas.getBoundingClientRect();

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    let clientX
    let clientY

    if ("touches" in e) {
        const touch = e.touches[0] ?? e.changedTouches[0];
        clientX = touch.clientX;
        clientY = touch.clientY;
    } else {
        clientX = e.clientX;
        clientY = e.clientY;
    }


    const x = (clientX - rect.left - centerX - CanvasDrawer.offset.x) / CanvasDrawer.scale;
    const y = (clientY - rect.top - centerY - CanvasDrawer.offset.y) / CanvasDrawer.scale;

    return { x, y };
}
